export const getBrowserLocation = async ({
  locationAddress = '',
  enableHighAccuracy = true,
  timeout = 10000,
  maximumAge = 0,
} = {}) => {
  if (typeof window === 'undefined' || !('navigator' in window) || !window.navigator.geolocation) {
    return {
      latitude: null,
      longitude: null,
      locationAddress,
      error: new Error('Geolocation is not supported in this environment.'),
    };
  }

  return await new Promise((resolve) => {
    window.navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;

        resolve({
          latitude,
          longitude,
          locationAddress: locationAddress || `Lat: ${latitude.toFixed(5)}, Lon: ${longitude.toFixed(5)}`,
          error: null,
        });
      },
      (error) => {
        resolve({
          latitude: null,
          longitude: null,
          locationAddress,
          error,
        });
      },
      {
        enableHighAccuracy,
        timeout,
        maximumAge,
      },
    );
  });
};

export const sanitizeLocationPayload = ({ latitude, longitude, locationAddress }) => {
  const payload = {};

  if (typeof latitude === 'number' && !Number.isNaN(latitude)) {
    payload.latitude = latitude;
  }

  if (typeof longitude === 'number' && !Number.isNaN(longitude)) {
    payload.longitude = longitude;
  }

  if (locationAddress) {
    payload.locationAddress = locationAddress;
  }

  return payload;
};

